import BpkBreadcrumb, {
  BpkBreadcrumbItem,
} from '@skyscanner/backpack-web/bpk-component-breadcrumb';

import type {
  BreadcrumbsProps,
  BreadcrumbItem,
} from '@shared/types/breadcrumbs';

import STYLES from './Breadcrumbs.module.scss';

import { withErrorBoundary } from '@shared/ui/components/ErrorBoundary';

const Breadcrumbs = ({ breadcrumbs: entries, metadata }: BreadcrumbsProps) => {
  const createBpkBreadcrumbItem = (
    { label, page_type_id: pageTypeId, url }: BreadcrumbItem,
    index: number,
    array: BreadcrumbItem[],
  ) => {
    const isLastItem = index === array.length - 1;
    return (
      <BpkBreadcrumbItem
        key={pageTypeId}
        active={isLastItem}
        href={isLastItem ? undefined : url}
        className={STYLES.Breadcrumbs__item}
      >
        {label}
      </BpkBreadcrumbItem>
    );
  };

  let links: JSX.Element[] | string = '';
  if (Array.isArray(entries)) links = entries.map(createBpkBreadcrumbItem);

  const schema = { __html: metadata };

  /* eslint-disable react/no-danger */
  return (
    <div id="breadcrumbs-root" className={STYLES.Breadcrumbs}>
      <script type="application/ld+json" dangerouslySetInnerHTML={schema} />
      <BpkBreadcrumb label="breadcrumbs">{links}</BpkBreadcrumb>
    </div>
  );
  /* eslint-enable react/no-danger */
};

const BreadcrumbsWithErrorBoundary = withErrorBoundary(
  Breadcrumbs,
  'breadcrumbs-component',
);

export default BreadcrumbsWithErrorBoundary;
